import React from "react";

import { Box, Card, CardContent, Chip, Icon, Typography, useTheme } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import SelectedStoreIconSvg from "assets/images/selected-store-icon.svg";

import { Store } from "modules/customer/insights/portfolioNew/store";

const StyledCard = withStyles(theme => ({
    root: {
        position: "absolute",
        zIndex: theme.zIndex.drawer,
        margin: theme.spacing(2),
        bottom: theme.spacing(2),
        width: theme.spacing(28),
        // @ts-ignore
        backgroundColor: theme.palette.background.insight
    }
}))(Card);

const StyledCardContent = withStyles(theme => ({
    root: {
        "&:last-child": {
            padding: theme.spacing(2)
        }
    }
}))(CardContent);

const StyledChip = withStyles(theme => ({
    root: {
        backgroundColor: (props: any) => props["data-background-color"],
        width: theme.spacing(3),
        height: theme.spacing(1.5)
    }
}))(Chip);

interface LegendProps {
    store?: Store,
    retailZoneColour: string
}

const Legend: React.FC<LegendProps> = (props) => {
    const { store, retailZoneColour } = props;
    const theme = useTheme();

    return (
        <StyledCard elevation={0}>
            <StyledCardContent>
                <Box display="flex">
                    <Icon fontSize="small">
                        <img src={SelectedStoreIconSvg} height={24} width={24} alt="portfolio-area-health-legend-selected-store-icon" />
                    </Icon>
                    <Typography variant="body1" component="div" style={{ paddingTop: theme.spacing(0.25), paddingLeft: theme.spacing(0.5) }} gutterBottom>
                        &nbsp;&nbsp;{store?.name} store
                    </Typography>
                </Box>
                <Typography variant="body1" component="div">
                    <StyledChip size="small" data-background-color={retailZoneColour} />
                    &nbsp;&nbsp;Retail zone
                </Typography>
            </StyledCardContent>
        </StyledCard>
    );
};

export default Legend;
